import {Controller} from "stimulus"

export default class extends Controller {
    connect() {
        const input = this.element.querySelector('input[type="tel"]');
        const dialCode = this.element.querySelector('input[data-dial-code="1"]');
        const intl = window.intlTelInput(input, {
            initialCountry: "bg",
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.min.js"
        })
        const initialCountryData = intl.getSelectedCountryData();

        input.addEventListener('countrychange', function () {
            let countryData = intl.getSelectedCountryData();
            if (!countryData.dialCode) {
                intl.setCountry(initialCountryData.iso2);
                countryData = intl.getSelectedCountryData();
            }
            input.value = `+${countryData.dialCode}`;
        })
        dialCode.value = `+${initialCountryData.dialCode}`

        let telValue = input.value.replace(/^0+/, '');
        if (telValue.startsWith(dialCode.value)) {
            telValue = telValue.slice(dialCode.value.length);
        }
        input.value = `+${initialCountryData.dialCode}` + telValue;
        console.log(input.value);
    }
}